import { render } from "./AlertDebarments.vue?vue&type=template&id=613d9b68&scoped=true"
import script from "./AlertDebarments.vue?vue&type=script&lang=js"
export * from "./AlertDebarments.vue?vue&type=script&lang=js"

import "./AlertDebarments.vue?vue&type=style&index=0&id=613d9b68&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613d9b68"]])

export default __exports__